import { CallApi } from '@signavio/kraken'

import { API_BASE } from '../../callApi'

import { schema } from './file'

export { collection, schema } from './file'

type FetchQueryType = {
  id: string
  workflowId: string
}

export const fetch =
  (callApi: CallApi) =>
  ({ id, workflowId }: FetchQueryType) =>
    callApi(`${API_BASE}/public/files/${id}?workflowId=${workflowId}`, schema)

export const create = (callApi: CallApi) => (_: unknown, file: File) => {
  const formData = new FormData()

  formData.append('files', file)

  return callApi(`${API_BASE}/public/files`, schema, {
    method: 'POST',
    body: formData,
  })
}
